import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';
import RFDatePickerField from '../../components/ReduxFormComps/RFDatePickerField';
import RFSelectWithOverrideComponent from '../../components/ReduxFormComps/RFSelectWithOverrideComponent';
import styles from './common/styles';
import Paper from '@material-ui/core/Paper'
import CopyIcon from '@material-ui/icons/FileCopy';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button'
import ContentRowSpace from './common/ContentRowSpace'

class DocFormApplicant extends React.Component {
    
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isOverrideAppFirstNameNotFound !== nextProps.isOverrideAppFirstNameNotFound) {
            return true;
        }
        if (this.props.isOverrideAppLastNameNotFound !== nextProps.isOverrideAppLastNameNotFound) {
            return true;
        }
        if (this.props.isOverrideAppStreetAddrLine1NotFound !== nextProps.isOverrideAppStreetAddrLine1NotFound) {
            return true;
        }
        if (this.props.isOverrideAppCityNotFound !== nextProps.isOverrideAppCityNotFound) {
            return true;
        }
        if (this.props.isOverrideAppStateNotFound !== nextProps.isOverrideAppStateNotFound) {
            return true;
        }
        if (this.props.isOverrideAppZipNotFound !== nextProps.isOverrideAppZipNotFound) {
            return true;
        }
        if (this.props.isOverrideAppSexNotFound !== nextProps.isOverrideAppSexNotFound) {
            return true;
        }
        if (this.props.isOverrideAppWorkPhoneNumNotFound !== nextProps.isOverrideAppWorkPhoneNumNotFound) {
            return true;
        }
        if (this.props.isOverrideAppHomePhoneNumNotFound !== nextProps.isOverrideAppHomePhoneNumNotFound) {
            return true;
        }
        if (this.props.isOverrideAppCountry !== nextProps.isOverrideAppCountry) {
            return true;
        }
        if (this.props.isOverrideAppBirthplaceCountry !== nextProps.isOverrideAppBirthplaceCountry) {
            return true;
        }
        return false;
    }

    copyBasicInfoOnclick(){
        const memEmpFirstName=this.props.memEmpFirstName
        const memEmpMiddleName=this.props.memEmpMiddleName
        const memEmpLastName=this.props.memEmpLastName
        const memEmpBirthdate=this.props.memEmpBirthdate
        const memEmpNameSuffix=this.props.memEmpNameSuffix
        const memEmpSSN=this.props.memEmpSSN

        if (memEmpFirstName){
            this.props.changeFieldValue('appFirstName',memEmpFirstName)
        }
        if (memEmpMiddleName){
            this.props.changeFieldValue('appMiddleName',memEmpMiddleName)
        }
        if (memEmpLastName){
            this.props.changeFieldValue('appLastName',memEmpLastName)
        }
        if (memEmpBirthdate){
            this.props.changeFieldValue('appBirthdate',memEmpBirthdate)
        }
        if (memEmpNameSuffix){
            this.props.changeFieldValue('appNameSuffix',memEmpNameSuffix)
        }
        if (memEmpSSN){
            this.props.changeFieldValue('appSSN',memEmpSSN)
        }
    }

    render(){
        const { gorgon,isOverrideAppFirstNameNotFound,isOverrideAppLastNameNotFound,
            isOverrideAppStreetAddrLine1NotFound,isOverrideAppCityNotFound,isOverrideAppStateNotFound,
            isOverrideAppZipNotFound,isOverrideAppSexNotFound,isOverrideAppWorkPhoneNumNotFound,
            isOverrideAppHomePhoneNumNotFound
         } = this.props;
        return (
            <div>
                <Paper>
                    <div className="container">
                        <ContentRowSpace />
                        <div className='row'>
                            <div className='col-sm'>
                                <Tooltip title="Copy Basic Information from Above">
                                    <Button variant="raised" color="primary" onClick={this.copyBasicInfoOnclick.bind(this)}>
                                        <CopyIcon />
                                        Copy Basic Information from Above
                                    </Button>
                                </Tooltip>
                            </div>    
                        </div>    
                        <ContentRowSpace />
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppFirstNameNotFound?(
                                <Field
                                    name="appFirstName"
                                    component={renderTextField}
                                    label="*Applicant First Name"
                                    style={styles.nameTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppFirstNameNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant First Name Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appMiddleName"
                                    component={renderTextField}
                                    label="Applicant Middle Name"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppLastNameNotFound?(
                                <Field
                                    name="appLastName"
                                    component={renderTextField}
                                    label="*Applicant Last Name"
                                    style={styles.nameTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppLastNameNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Last Name Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appNameSuffix"
                                    component={renderTextField}
                                    label="Applicant Name Suffix"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>    
                        </div>  
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="appEmail"
                                    component={renderTextField}
                                    label="Email Address"
                                    style={styles.textFieldStyle}
                                />
                            </div>
                        </div>     
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppStreetAddrLine1NotFound?(
                                <Field
                                    name="appStreetAddrLine1"
                                    component={renderTextField}
                                    multiline
                                    rowsMax="2"
                                    label="*Street Address Line 1"
                                    style={styles.addrTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppStreetAddrLine1NotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Street Address Line 1 Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appStreetAddrLine2"
                                    component={renderTextField}
                                    multiline
                                    rowsMax="2"
                                    label="Street Address Line 2"
                                    style={styles.addrTextFieldStyle}
                                />
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppCityNotFound?(
                                <Field
                                    name="appCity"
                                    component={renderTextField}
                                    label="*City"
                                    style={styles.addrTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppCityNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant City Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                {!isOverrideAppStateNotFound?(
                                <Field
                                    label="*State"
                                    name="appState"
                                    datas={gorgon.states}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'name'}
                                    customStyle={styles.addrTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppStateNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant State Not Found in Document" />
                            </div>
                        </div> 
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppZipNotFound?(
                                <Field
                                    name="appZip"
                                    component={renderTextField}
                                    label="*Zip"
                                    style={styles.addrTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppZipNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Zip Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <RFSelectWithOverrideComponent 
                                    label="Country"
                                    fieldName="appCountry"
                                    datas={gorgon.countries}
                                    dataDict={{code: 'code', desc: 'name'}}
                                    customStyle={styles.addrTextFieldStyle}
                                    overrideCheckBoxFieldName='isOverrideAppCountry'
                                    overrideCheckBoxLabel='Override This Country field'
                                    isOverrideAppCountry={this.props.isOverrideAppCountry}
                                />
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppSexNotFound?(
                                <Field
                                    label="*Sex"
                                    name="appSex"
                                    datas={gorgon.genders}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'name'}
                                    customStyle={styles.addrTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppSexNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Sex Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appBirthdate"
                                    component={RFDatePickerField}
                                    label="Birthdate"
                                    inputDateFormat='MM/DD/YYYY'
                                    style={styles.nameTextFieldStyle}
                                    inputNote="US date format MM/DD/YYYY"
                                /> 
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    label="Birthplace - State"
                                    name="appBirthplaceState"
                                    datas={gorgon.states}
                                    component={RFSelectField}
                                    codeField={'code'}
                                    descField={'name'}
                                    customStyle={styles.addrTextFieldStyle}
                                />
                            </div>
                            <div className='col-sm'>
                                <RFSelectWithOverrideComponent 
                                    label="Birthplace - Country"
                                    fieldName="appBirthplaceCountry"
                                    datas={gorgon.countries}
                                    dataDict={{code: 'code', desc: 'name'}}
                                    customStyle={styles.addrTextFieldStyle}
                                    overrideCheckBoxFieldName='isOverrideAppBirthplaceCountry'
                                    overrideCheckBoxLabel='Override This Birthplace Country field'
                                    isOverrideAppBirthplaceCountry={this.props.isOverrideAppBirthplaceCountry}
                                />
                            </div>
                        </div>   
                        <div className="row">
                            <div className='col-sm'>
                                <Field
                                    name="appSSN"
                                    component={renderTextField}
                                    label="Social Security Number"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppWorkPhoneNumNotFound?(
                                <Field
                                    name="appWorkPhoneNum"
                                    component={renderTextField}
                                    label="*Work Phone Number"
                                    style={styles.nameTextFieldStyle}
                                />
                                ):null}    
                                <Field name="isOverrideAppWorkPhoneNumNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Work Phone Number Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appWorkPhoneExt"
                                    component={renderTextField}
                                    label="Work Phone Extension"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                {!isOverrideAppHomePhoneNumNotFound?(
                                <Field
                                    name="appHomePhoneNum"
                                    component={renderTextField}
                                    label="*Home Phone Number"
                                    style={styles.nameTextFieldStyle}
                                />
                                ):null}
                                <Field name="isOverrideAppHomePhoneNumNotFound" 
                                component={RFCheckboxField} 
                                label="Applicant Home Phone Number Not Found in Document" />
                            </div>
                            <div className='col-sm'>
                                <Field
                                    name="appHomePhoneExt"
                                    component={renderTextField}
                                    label="Home Phone Extension"
                                    style={styles.nameTextFieldStyle}
                                />
                            </div>
                        </div>              
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

export default connect(mapStateToProps)(DocFormApplicant);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormApplicant.js